// ===== Blog Archive Year Toggle =====
document.addEventListener('DOMContentLoaded', function () {
  console.log('✅ custom-dod.js loaded');

  const buttons = document.querySelectorAll('.year-toggle');
  console.log('Toggle buttons found:', buttons.length);

  buttons.forEach(function (button) {
    button.addEventListener('click', function () {
      const yearId = button.getAttribute('data-toggle');
      const target = document.getElementById(yearId);

      console.log('Clicked:', yearId, target);

      if (target) {
        target.classList.toggle('hidden');
        button.textContent = target.classList.contains('hidden') ? '+' : '−';
      }
    });
  });
});


